import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Constants, Trk } from "../../../../constants";
import { SubscriptionType, UpsellPanelSteps, UserAccessLevelType } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetRedirect } from "../../hooks/useRedirectContext";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../../hooks/useUpsellWidgetModelContext";
import { useUpsellWidgetSMSTokenTimerContext } from "../../hooks/useUpsellWidgetSMSTokenTimerContext";
import { useActivateTrialMutation } from "../../services/hooks/useLoginMutation";
import { useResendSMSTokenMutation, useVerifySMSTokenMutation } from "../../services/hooks/useMFAMutations";
import ValidationErrorsSummary from "../UpSellWidgetContainer/ValidationErrorsSummary";
import { VerificationCodeInput } from "./FormControls/VerificationCodeInput";

export const Step2SMSToken = () => {
    const model = useUpsellWidgetModel();
    const { currentStep, baseProps, updateBaseProps, handleErrorResponse, boldClass, onSubmitError, handleProductActivation, setIsUpsellContainerLoading, handleActivateTrialSuccess } = useUpsellWidgetContainer();
    const { resetTimer, remainingTime, getRemainingTimeText } = useUpsellWidgetSMSTokenTimerContext();
    const { redirectToUrl } = useUpsellWidgetRedirect();

    if (currentStep !== UpsellPanelSteps.Step2SMSToken) {
        return null;
    }
    
    const [formErrors, setFormErrors] = useState(null);
    const { mutate: verifySMSToken } = useVerifySMSTokenMutation();
    const { mutate: resendSMSToken } = useResendSMSTokenMutation();
    const { mutate: activateTrial, isError: isActivateTrialError, isSuccess: isActivateTrialSuccess } = useActivateTrialMutation();

    const {
        register,
        handleSubmit,
        formState: { errors },
        resetField
    } = useForm();

    const handlRequestSMSTokenSuccess = (response) => {
        const sendResponseUpdates = (successMessage) => {
            updateBaseProps({
                twilioStatusModel: {
                    status: response.twilioStatus,
                    failed: response.twilioFailed
                },
                successMessage: successMessage
            });
        }

        resetTimer();
        if (response.status === Constants.RequestStatus.SUCCESS && !response.twilioFailed) {
            sendResponseUpdates("SMS code has been re-sent");
            resetField('subscriberSMSToken');
        } else {
            sendResponseUpdates();
            alert("SMS code resend has failed.");
        }
        setIsUpsellContainerLoading(false);
    }

    const handleLoginSuccess = (response) => {
        if (response.status === Constants.RequestStatus.SUCCESS) {
            let activateTrial = false;
            if (model.usePopupOverlay && model.productHandle === SubscriptionType.SUBSCRIPTION_INSIGHTS_FREE_PRODUCT_HANDLE) {
                activateTrial = true;
            }
            AnalyticsTrack(Trk.ACCOUNT.MOBILE_VERIFICATION_SUCCEEDED,
                {
                    category: "account",
                    action: "mobile_verification_succeeded"
                });

            handleProductActivation(response, redirectToUrl, model, activateTrial, onActivateTrial);
        } else if (response.errors && response.errors.length > 0) {
            handleErrorResponse(response.errors, setFormErrors);
        }

        setIsUpsellContainerLoading(false);
    }
    const onSubmit = (formData) => {
        setIsUpsellContainerLoading(true);
        updateBaseProps({
            successMessage: null,
            user: {
                ...baseProps.user,
                subscriberSMSToken: formData.subscriberSMSToken
            }
        });
        verifySMSToken({
            ...formData,
            subscriberId: baseProps.user.subscriberId,
            entryPointUrl: baseProps.entryPointUrl,
            entryPoint: model.entryPoint,
            targetBuid: model.targetBuid,
            byPassPhoneVerification: false,
            affiliateCodeData: localStorage.getItem(Constants.AFFILIATE_CODE),
            urlReferrer: document.referrer
        }, {
            onSuccess: handleLoginSuccess,
            onError: (error) => onSubmitError(error)
        });
    };

    const onRequestTokenClick = () => {
        setIsUpsellContainerLoading(true);
        updateBaseProps({
            successMessage: null
        });
        resendSMSToken(baseProps.user.mobile,
            {
                onSuccess: handlRequestSMSTokenSuccess,
                onError: (error) => onSubmitError(error)
            })
    };

    const onActivateTrial = () => {
        setIsUpsellContainerLoading(true);
        setFormErrors(null);
        activateTrial({
            subscriberId: baseProps.user.subscriberId,
            subscribernonce: baseProps.user.subscribernonce,
            subscribersmstoken: baseProps.user.subscriberSMSToken,
            entryPointUrl: baseProps.entryPointUrl,
            entryPoint: model.entryPoint,
            fromBuid: model.targetBuid,
            byPassPhoneVerification: model.byPassPhoneVerification,
            requiredAccessLevel: model.requiredAccessLevel ?? UserAccessLevelType.Anonymous,
            promoid: model.PromoID,
            affiliateCodeData: localStorage.getItem(Constants.AFFILIATE_CODE),
            urlReferrer: document.referrer
        }, {
            onSuccess: (response) => handleActivateTrialSuccess(response, redirectToUrl, setFormErrors),
            onError: (error) => onSubmitError(error)
        });
    }

 
    return (
        <div className="step2">
            {(isActivateTrialError || isActivateTrialSuccess) || (errors || formErrors) && (<div className="upsell-container-content">
                <ValidationErrorsSummary validationErrors={{ ...errors, ...formErrors }} />
            </div>)}
            <form className="join-form-inline form-is-custom form-disable-pristine-error" onSubmit={handleSubmit(onSubmit)} noValidate>
                <div className="row">
                    {!baseProps.twilioStatusModel?.failed ? (
                        <div className="bs4-landing-button-center">
                            <div className="col-md-12">
                                <VerificationCodeInput register={register} errors={errors} name='subscriberSMSToken' displayInlineError={true} />
                            </div>
                            <div className="col-md-12">
                                <button className={`btn btn-primary btn-wide btn-brand-style-with-pad-sm pt-2 font-19-no-line-height mb-32 ${boldClass}`} type="submit">
                                    Verify code & start trial
                                </button>
                            </div>
                        </div>
                    ) : (
                        <div className="col-md-12">
                            <p>SMS code cannot be sent due to: {baseProps.twilioStatusModel.status}</p>
                        </div>
                    )}
                    <div className="col-md-12 text-center mx-auto">
                        <div className="text-color-gray-16 font-19">
                            Didn't get the code?
                            <a className={classNames(
                                'link-primary text-underline pl-2 cursor-pointer',
                                {
                                    'anchor-disabled': remainingTime > 0
                                }
                            )} onClick={onRequestTokenClick}>
                                Resend code
                            </a>
                            {remainingTime > 0 && (
                                <div className="pt-2">
                                    Resend code is disabled for {getRemainingTimeText()} sec. Please wait
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};
